export const MEDIA_SIZES = {
  MOBILE: "480px",
  TABLET: "768px",
  TABLET_L: "961px",
  LAPTOP: "1024px",
  DESKTOP: "1200px",
}
